import * as React from "react";
import { LoginFunc } from "./loginUtils";
import { AxiosError } from "axios";

const LoginContext = React.createContext<{
  login: LoginFunc;
  loginAuth: any;
  error: AxiosError;
  setError: (error: AxiosError) => {};
}>({} as any);
LoginContext.displayName = "LoginContext";

export default LoginContext;
